import { Box, Text } from "@chakra-ui/react";
import * as React from "react";

interface ChoiceCardProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  selected: boolean;
  onSelect: () => void;
  /** Extra content below the description (e.g. controls shown when selected). */
  children?: React.ReactNode;
}

export function ChoiceCard({
  children,
  description,
  onSelect,
  selected,
  title,
}: ChoiceCardProps) {
  return (
    <Box
      background={selected ? "white" : "bg.subtle"}
      borderRadius="l2"
      boxShadow={selected ? "choiceSelected" : "insetRing"}
      cursor={"pointer" as any}
      onClick={onSelect}
      paddingX="4"
      paddingY="3.5"
      _hover={selected ? undefined : { boxShadow: "choiceHover" }}
    >
      <Text
        color="fg.ink"
        fontSize="sm"
        fontWeight="medium"
        lineHeight={"20px" as any}
      >
        {title}
      </Text>
      {description && (
        <Text
          color="fg.muted"
          fontSize={"13px" as any}
          lineHeight={"1.55" as any}
          marginTop="1"
        >
          {description}
        </Text>
      )}
      {children}
    </Box>
  );
}
